import type { HTMLAttributes, ReactNode, FC, Ref } from "react";
import { mergeClasses } from "@huub-web/utils";

import { groupContainerStyle, groupStyle } from "./Group.css";

export type GroupProps = HTMLAttributes<HTMLDivElement> & {
  direction?: "horizontal" | "vertical";
  children?: ReactNode;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * A button group component that groups buttons together.
 */
export const Group: FC<GroupProps> = ({
  direction = "horizontal",
  className,
  children,
  ref,
  ...props
}) => (
  <div
    ref={ref}
    className={mergeClasses(
      className,
      groupStyle,
      groupContainerStyle({ direction }),
    )}
    data-direction={direction}
    {...props}
  >
    {children}
  </div>
);
